import { Controller } from '@hotwired/stimulus'

// Syncs collapse open/closed state across labels and vessel forms: when one section is shown/hidden,
// all same-named sections get the same state. Runs sync on event for DOM updates.
const SECTION_CLASSES = [
  'vessel-particulars',
  'project-details',
  'speeds-consumption',
  'mvg-index',
  'mvg-sisters-index',
  'mvg-custom-index'
]

export default class extends Controller {
  connect() {
    this.element.addEventListener('shown.bs.collapse', (e) => this.onCollapseChange(e, true))
    this.element.addEventListener('hidden.bs.collapse', (e) => this.onCollapseChange(e, false))
    this.element.addEventListener('value-guidance:syncCollapseStyles', () => this.syncAllSections())
  }

  sectionClassFromElement(el) {
    if (!el || !el.classList) return null
    return SECTION_CLASSES.find((cls) => el.classList.contains(cls)) || null
  }

  onCollapseChange(e, show) {
    const sectionClass = this.sectionClassFromElement(e.target)
    if (!sectionClass) return
    this.element.querySelectorAll(`.${sectionClass}`).forEach((node) => {
      node.classList.toggle('show', show)
    })
    // Arrow flip is handled globally by startCollapsingSections() in _calculator.js
  }

  syncAllSections() {
    SECTION_CLASSES.forEach((sectionClass) => {
      const nodes = this.element.querySelectorAll(`.${sectionClass}`)
      if (nodes.length === 0) return
      const first = nodes[0]
      const hasShow = first.classList.contains('show')
      nodes.forEach((node) => node.classList.toggle('show', hasShow))
    })
  }
}
